import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeService } from '../../Services/home.service';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { doAnimate } from '../../Shared/app.helpers';
import { Route } from '@angular/compiler/src/core';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  Tourdateslist: any[] = [];
  LegendsData: any[];
  sponsorlist: any[];
  isLoading: boolean;
  subscription: Subscription;

  constructor(private sanitizer: DomSanitizer, private homeService: HomeService, public appComponent: AppComponent, private router: Router) { }

  ngOnInit() {
    this.getWebpage()
  }

 
  getWebpage() {
    this.isLoading = true;
    this.subscription = this.homeService.getwebpage().subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && res.Response && res.Response.Data) {
          this.Tourdateslist = res.Response.Data.NearestEvents;
          this.LegendsData = res.Response.Data.LegendsList.DataList;
          this.sponsorlist = res.Response.Data.SponsorList;
        }
      },
      (error) => {
        console.error('Error fetching Home Data:', error);
        
      }
    );
  }

 
  //gotoRoute(url: string) {
  //  window.open(url, '_blank');
  //}

  onEventdetailClick($event, eventseoname, isEventEnd) {
    $event.stopPropagation();

    if (isEventEnd == false) {
      doAnimate();
      setTimeout(() => {
        this.router.navigate(['/event-details', eventseoname]);
      }, 500);
    }
    else {
      doAnimate();
      setTimeout(() => {
        this.router.navigate(['/event-details', eventseoname]);
      }, 500);
    }
  }
}
